export default __webpack_public_path__ + "static/thibault-desktop-64a741ef7747023984d41e559d67a343.webp";